export default "__VITE_ASSET__99bd842c__"